import Platform from '../base';
import navigationKeys from './config/keys/navigation';
import remoteKeys from './config/keys/remote-keys';
import './libs/webOS';
import storage from '../../helpers/storage';

const deviceYear = {
  '1.0': '2014',
  '2.0': '2015',
  '3.0': '2016',
  '3.5': '2017',
  '4.0': '2018',
  '4.5': '2019',
  '5.0': '2020',
  '6.0': '2021',
};

class Webos extends Platform {
  navigationKeys = navigationKeys;
  remoteKeys = remoteKeys;
  deviceInfo = {};

  initialize(opt) {
    super.initialize(opt);

    /* (function() {
      var s = document.createElement('script');
      s.src = 'https://remotejs.com/agent/agent.js';
      s.setAttribute('data-consolejs-channel', '707b7bc1-e4a3-dc8e-921a-87737fdcf28b');
      document.head.appendChild(s);
    })();*/

    /*

    const debugDiv = document.createElement('div');
    debugDiv.id = 'debug';
    debugDiv.setAttribute(
      'style',
      'bottom:0; display: block; position: absolute; z-index: 99999; width: 1280px; min-height: 660px;\n' +
        'background-color: darkblue; padding: 10px 50px; font-size: 32px; color: white; opacity: 0.5; vertical-align: bottom',
    );

    document.body.appendChild(debugDiv);

    console.log = function() {
      var debug = document.getElementById('debug');
      Array.prototype.forEach.call(arguments, function(message) {
        if (typeof message === 'object') message = JSON.stringify(message);
        var newMsg = document.createElement('div');
        newMsg.innerHTML = message;
        debug.appendChild(newMsg);
        debug.scrollTop += 50;
      });
    };*/

    return Promise.all([this.setSystemInfo(), this.getConnectionTypeFromTV()]);
  }

  _getDeviceId() {
    let sn = window.webOS.device.serialNumber;
    if (sn === 'Unknown' || !sn) {
      return undefined;
    }
    return sn;
  }

  setSystemInfo() {
    return new Promise((resolve, reject) => {
      window.webOS.service.request('luna://com.webos.service.tv.systemproperty', {
        method: 'getSystemInfo',
        parameters: {
          keys: ['firmwareVersion', 'modelName', 'sdkVersion', 'UHD'],
        },
        onSuccess: (inResponse) => {
          const isSucceeded = inResponse.returnValue;
          const self = this;
          if (isSucceeded) {
            this.deviceInfo.name = inResponse.modelName;
            this.deviceInfo.firmware = inResponse.firmwareVersion;
            this.deviceInfo.supportsUHD = JSON.parse(inResponse.UHD); // string type by vendor docs ("true"|"false")
            this.deviceInfo.sdkVersion = inResponse.sdkVersion;
          }

          const webOSVersion = parseInt(inResponse.sdkVersion.charAt(0));
          if (webOSVersion < 3) {
            this.deviceInfo.uuid = this.getDUID();
            resolve();
          } else {
            window.webOS.service.request('luna://com.webos.service.sm', {
              method: 'deviceid/getIDs',
              parameters: {
                idType: ['LGUDID'],
              },
              onSuccess: function (response) {
                const LGUDID = response.idList[0].idValue;
                self.deviceInfo.uuid = LGUDID ? LGUDID : self.getDUID();
                resolve();
              },
              onFailure: function () {
                resolve();
              },
            });
          }
        },
        onFailure: () => {
          resolve();
        },
      });
    });
  }

  isMouseControlSupported() {
    return true;
  }

  exit() {
    window.webOS.platformBack();
  }

  getPlatformVersion() {
    return this.deviceInfo.sdkVersion || super.getPlatformVersion();
  }

  getFirmwareVersion() {
    return this.deviceInfo.firmware || super.getFirmwareVersion();
  }

  getMainSDKVersion() {
    const sdk = parseFloat(this.getPlatformVersion() || 0);
    const sdkFloor = Math.floor(sdk);
    if (sdk >= 3 && sdk - sdkFloor >= 0.5) {
      return `${sdkFloor}.5`;
    }
    return `${sdkFloor}.0`;
  }

  getModelYear() {
    const year = deviceYear[this.getMainSDKVersion()] || super.getModelYear();
    return parseInt(year, 10);
  }

  getModelName() {
    return this.deviceInfo.name || super.getModelName();
  }

  getUID() {
    return this.deviceInfo.uuid || super.getUID();
  }

  getDeviceType() {
    return this.getModelYear() <= 2017 ? 'OLD_TV' : 'SMART_TV';
  }

  getDeviceRegistrationType() {
    return 'LG WebOs';
  }

  getDUID() {
    let duid = storage.get('duid');

    if (!duid) {
      duid = (Date.now().toString(36) + Math.random().toString(36).substr(2, 9)).toUpperCase();
      storage.set('duid', duid);
    }

    return duid;
  }

  getBrand() {
    return 'LG';
  }

  getName() {
    return 'WebOS';
  }

  getVASTAppPlatformName() {
    return 'lgst';
  }

  getConnectionType() {
    return this.deviceInfo.connectionType || super.getConnectionType();
  }

  getConnectionTypeFromTV() {
    return new Promise((resolve) => {
      this.deviceInfo.connectionType = 'Unknown';
      const self = this;

      window.webOS.service.request('luna://com.palm.connectionmanager', {
        method: 'getStatus',
        onSuccess: function (inResponse) {
          const isSucceeded = inResponse.returnValue;

          if (isSucceeded) {
            if (inResponse.wired.state === 'connected') {
              self.deviceInfo.connectionType = 'Ethernet';
            }
            if (inResponse.wifi.state === 'connected') {
              self.deviceInfo.connectionType = 'Wi-Fi';
            }
            if (inResponse.wifiDirect.state === 'connected') {
              self.deviceInfo.connectionType = 'Wi-Fi Direct';
            }
          }
          resolve();
        },
        onFailure: function (inError) {
          console.error('Failed to get network state');
          console.error(`[${inError.errorCode}]: ${inError.errorText}`);
          resolve();
        },
      });
    });
  }
}

export default Webos;
